import React, { Component } from 'react'
import EntityList from './../../components/entityList';
import TrailerEdit from './trailerEdit';
import Trailers from './trailers';

import utils from '../../misc/utils';
var config = utils.getConfig();

class TrailersInactive extends Trailers {
  constructor(props, context) {
    super(props, context);

    this.state.scope = 'inactive';
  }

  render() {
    return Trailers.prototype.render.call(this);
  }
}

export default TrailersInactive;



/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/trailers.inactive.js
 **/